<section #tableWrapper tabindex="0" class="ctx-table__content__wrapper">
  <!-- Table Overlay -->
  <span
    *ngIf="
      (resourceTableService.tableLoading$ | async) ||
      (resourceTableService.isFilterActive &&
        resourceTableService.dataSource.value.length === 0) ||
      (resourceTableService.isSearchActive &&
        resourceTableService.dataSource.value.length === 0) ||
      resourceTableService.tableErrorMessage ||
      resourceTableService.dataSource.value.length === 0
    "
    class="ctx-table__content__loader p-6 box-border absolute"
    [ngClass]="{
      'cursor-wait': (resourceTableService.tableLoading$ | async) === true,
      'cursor-not-allowed':
        (resourceTableService.tableLoading$ | async) === false &&
        resourceTableService.tableErrorMessage,
      'cursor-help':
        (resourceTableService.tableLoading$ | async) === false &&
        (resourceTableService.dataSource.value.length === 0 ||
          resourceTableService.isFilterActive ||
          resourceTableService.isSearchActive)
    }"
    [ngSwitch]="true"
    [style.max-width]="tableWidth"
  >
    <!-- Table messages -->
    <p class="max-w-prose">
      <!-- Spinner -->
      <mat-spinner
        class="mx-auto"
        *ngSwitchCase="resourceTableService.tableLoading$ | async"
      ></mat-spinner>

      <!-- Empty filter message -->
      <ng-container
        *ngSwitchCase="
          (resourceTableService.tableLoading$ | async) === false &&
          resourceTableService.isFilterActive &&
          !resourceTableService.isSearchActive &&
          resourceTableService.tableErrorMessage === null &&
          resourceTableService.dataSource.value.length === 0
        "
      >
        <hlm-icon name="FILTER"></hlm-icon> The currently active filter(s)
        returned no results.
      </ng-container>

      <!-- Empty search message -->
      <ng-container
        *ngSwitchCase="
          (resourceTableService.tableLoading$ | async) === false &&
          resourceTableService.isSearchActive &&
          !resourceTableService.isFilterActive &&
          resourceTableService.tableErrorMessage === null &&
          resourceTableService.dataSource.value.length === 0
        "
        ><hlm-icon name="MANAGE_SEARCH"></hlm-icon> The currently active search
        returned no results.</ng-container
      >

      <!-- Empty search and filter message -->
      <ng-container
        *ngSwitchCase="
          (resourceTableService.tableLoading$ | async) === false &&
          resourceTableService.isSearchActive &&
          resourceTableService.isFilterActive &&
          resourceTableService.tableErrorMessage === null &&
          resourceTableService.dataSource.value.length === 0
        "
        ><hlm-icon name="MANAGE_SEARCH"></hlm-icon>
        <hlm-icon name="FILTER"></hlm-icon> The currently active search query or
        filter returned no results.</ng-container
      >

      <!-- Error message -->
      <ng-container
        *ngSwitchCase="
          (resourceTableService.tableLoading$ | async) === false &&
          resourceTableService.tableErrorMessage !== null
        "
      >
        <hlm-icon name="ERROR"></hlm-icon>
        {{ resourceTableService.tableErrorMessage }}
      </ng-container>

      <!-- Default empty message -->
      <ng-container
        *ngSwitchCase="
          (resourceTableService.tableLoading$ | async) === false &&
          resourceTableService.dataSource.value.length === 0 &&
          !resourceTableService.isFilterActive &&
          resourceTableService.tableErrorMessage === null &&
          !resourceTableService.isSearchActive
        "
        ><hlm-icon name="HELP"></hlm-icon>
        {{ resourceTableService.tableEmptyMessage }}</ng-container
      >
    </p>
  </span>

  <table
    mat-table
    class="mat-table--paginated border-separate"
    [dataSource]="resourceTableService"
    matSort
    (matSortChange)="handleSortChange($event)"
    matSortActive="createdAt"
    matSortDirection="desc"
    matSortDisableClear
  >
    <!-- Checkboxes -->
    <ng-container
      *ngIf="resourceTableService.actions.selection"
      matColumnDef="checkbox"
    >
      <th mat-header-cell *matHeaderCellDef class="w-fit">
        <mat-checkbox
          *ngIf="resourceTableService.selections.isMultipleSelection()"
          (change)="$event ? resourceTableService.toggleAllTableRows() : null"
          [checked]="
            resourceTableService.selections.hasValue() &&
            resourceTableService.allTableRowsSelected
          "
          [indeterminate]="
            resourceTableService.selections.hasValue() &&
            !resourceTableService.allTableRowsSelected
          "
        ></mat-checkbox>
      </th>

      <td mat-cell *matCellDef="let row" class="w-fit">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? resourceTableService.selections.toggle(row) : null"
          [checked]="resourceTableService.selections.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container
      matColumnDef="actions"
      *ngIf="
        resourceTableService.actions.menuActions &&
        resourceTableService.actions.menuActions.length !== 0
      "
      stickyEnd
    >
      <th
        mat-header-cell
        *matHeaderCellDef
        class="border-l-2 border-solid border-0"
      >
        Actions
      </th>

      <td
        mat-cell
        *matCellDef="let row"
        class="border-l-2 border-solid border-0"
      >
        <span class="flex flex-row justify-center w-full">
          <ctx-resource-actions
            [resourceTableService]="resourceTableService"
            [resource]="row"
            type="icon"
          ></ctx-resource-actions>
        </span>
      </td>
    </ng-container>
    <!-- id -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>

      <td mat-cell *matCellDef="let row">
        <span class="font-mono">{{ row.id }}</span>
      </td>
    </ng-container>
    <!-- id -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="w-fit">
        Creation Date
      </th>

      <td mat-cell *matCellDef="let row" class="w-full">
        <span class="font-mono">{{ row.createdAt | date }}</span>
      </td>
    </ng-container>

    <!-- All column definitions -->
    <ng-container *ngFor="let column of resourceTableService.columns">
      <ng-container [matColumnDef]="column.property"
        >have commented on
        <!-- Header -->
        <th
          mat-header-cell
          mat-sort-header="{{
            column.sortProperty ? column.sortProperty : column.property
          }}"
          [disabled]="!isColumnSortable(column.property)"
          *matHeaderCellDef
          class="w-fit first:pl-8"
        >
          {{ getResourceDisplayName(column.property, projectName) }}
        </th>
        <!-- Data -->
        <ng-container>
          <td mat-cell *matCellDef="let row" class="w-fit first:pl-8">
            <ng-container [ngSwitch]="column.displayType">
              <!-- Link -->
              <ng-container *ngSwitchCase="'link'">
                <!-- The link columnType renders links with router link set ot the id property -->
                <!-- Icon for License-related columns -->
                <a
                  [routerLink]="getObjectProperty(row, 'id')"
                  class="ph-no-capture"
                  [ngClass]="isRowLicenseBased(row) ? 'font-mono' : ''"
                >
                  <hlm-icon
                    *ngIf="isRowLicenseBased(row)"
                    class="opacity-80 mr-1"
                    inline
                    [size]="'xs'"
                    aria-hidden="true"
                    [name]="getIconForLicense(row.type)"
                  ></hlm-icon
                  >{{ getObjectProperty(row, column.property) }}</a
                >
              </ng-container>

              <!-- Name -->
              <ng-container *ngSwitchCase="'name'">
                <code class="ph-no-capture">
                  {{ getObjectProperty(row, column.property) }}
                </code>
              </ng-container>

              <!-- Date -->
              <ng-container *ngSwitchCase="'date'">
                <span class="font-mono">{{
                  getObjectProperty(row, column.property) | date
                }}</span>
              </ng-container>

              <!-- Operating System -->
              <ng-container *ngSwitchCase="'operatingSystem'">
                @if(getIconForOs(getObjectProperty(row, column.property))){
                <hlm-icon
                  class="opacity-80"
                  [name]="getIconForOs(getObjectProperty(row, column.property))"
                ></hlm-icon>
                }
                <span class="font-mono">
                  {{ getObjectProperty(row, column.property) }}
                </span>
              </ng-container>

              <!-- Flag -->
              <ng-container *ngSwitchCase="'flag'">
                <span class="font-mono uppercase">{{
                  getObjectProperty(row, column.property)
                }}</span>
              </ng-container>

              <!-- Seconds -->
              <ng-container *ngSwitchCase="'seconds'">
                <span class="font-mono">{{
                  formatSecondsProperty(
                    getObjectProperty(row, column.property),
                    column.property
                  )
                }}</span>
              </ng-container>

              <ng-container *ngSwitchCase="'maintenanceValidity'">
                <span class="font-mono">
                  @if( getObjectProperty(row, column.property) === 0){ Lifetime
                  } @else {
                  {{
                    formatSecondsProperty(
                      getObjectProperty(row, column.property),
                      column.property
                    )
                  }}
                  }</span
                >
              </ng-container>
              <!-- format for properties for which unlimited===-1 -->
              <ng-container *ngSwitchCase="'unlimitedCheck'">
                {{ formatUnlimited(getObjectProperty(row, column.property)) }}
              </ng-container>
              <!-- Validity -->
              <ng-container *ngSwitchCase="'licenseValidity'">
                {{ formatLicenseValidity(row) }}
              </ng-container>
              <!-- Expires In -->
              <ng-container *ngSwitchCase="'licenseExpiresIn'">
                {{ formateLiceseEXpiresIn(row) }}
              </ng-container>
              <ng-container *ngSwitchCase="'activations'">
                <span>
                  {{ row.totalActivations | number }} /
                  {{ formatAllowedActivations(row.allowedActivations) }}
                </span>
              </ng-container>
              <!-- License Activations -->
              <ng-container *ngSwitchCase="'licenseActivations'">
                {{ getLicenseActivations(row) }}
              </ng-container>

              <!-- License Deactivations -->
              <ng-container *ngSwitchCase="'licenseDeactivations'">
                {{ getLicenseDeactivations(row) }}
              </ng-container>

              <!-- License Status -->
              <ng-container *ngSwitchCase="'licenseStatus'">
                <span class="font-mono uppercase">{{
                  getLicenseStatus(row)
                }}</span>
              </ng-container>

              <!-- Number -->
              <ng-container *ngSwitchCase="'number'">
                {{ getObjectProperty(row, column.property) | number }}
              </ng-container>

              <!-- Truncate -->
              <ng-container *ngSwitchCase="'truncateText'">
                <section class="max-w-md truncate">
                  {{ getObjectProperty(row, column.property) }}
                </section>
              </ng-container>

              <!-- File Size -->
              <ng-container *ngSwitchCase="'fileSize'">
                {{ formatFilesize(getObjectProperty(row, column.property)) }}
              </ng-container>

              <!-- Release Files -->
              <ng-container *ngSwitchCase="'files'">
                <ctx-view-in-modal-button
                  [config]="{
                    title: getResourceDisplayName(column.property, projectName),
                    arrayOfObjects: getObjectProperty(row, column.property),
                    columnsToDisplay: [
                      'name',
                      'url',
                      'size',
                      'downloads',
                      'secured',
                      'published'
                    ],
                    label: 'View | ' + row.files.length
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!-- Metadata -->
              <ng-container *ngSwitchCase="'metadata'">
                <ctx-view-in-modal-button
                  [config]="{
                    title: getResourceDisplayName(column.property, projectName),
                    arrayOfObjects: sortByKey(
                      getObjectProperty(row, column.property)
                    ),
                    columnsToDisplay: ['key', 'value', 'viewPermissions']
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!--Activation  Metadata -->
              <ng-container *ngSwitchCase="'activationMetadata'">
                <ctx-view-in-modal-button
                  [config]="{
                    title: getResourceDisplayName(column.property, projectName),
                    arrayOfObjects: sortByKey(
                      getObjectProperty(row, column.property)
                    ),
                    columnsToDisplay: ['key', 'value']
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!-- Meter Attributes -->
              <ng-container *ngSwitchCase="'meterAttributes'">
                <ctx-view-in-modal-button
                  [config]="{
                    title: getResourceDisplayName(column.property, projectName),
                    arrayOfObjects: getObjectProperty(row, column.property),
                    columnsToDisplay: isRowLicenseBased(row)
                      ? meterAttributeColumns
                      : ['name', 'uses']
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!-- Feature Flags -->
              <ng-container *ngSwitchCase="'featureFlags'">
                <ctx-view-in-modal-button
                  [config]="{
                    title: getResourceDisplayName(column.property, projectName),
                    arrayOfObjects: getObjectProperty(row, column.property),
                    columnsToDisplay: ['name', 'enabled', 'data']
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>
              <!-- Features Entitlements -->
              <ng-container *ngSwitchCase="'featuresEntitlements'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                    component: column.modalComponent,
                    resource: row,
                    property: 'id',
                }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!-- Linked Products displays product names linked to the resource -->
              <ng-container *ngSwitchCase="'linkedUserGroups'">
                <span class="ph-no-capture">
                  {{
                    getLinkedUserGroups(getObjectProperty(row, 'userGroups'))
                  }}
                </span>
              </ng-container>

              <!-- Audit Log Changes -->
              <ng-container *ngSwitchCase="'auditLogChanges'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                    component: column.modalComponent,
                    resource: row,
                    property: 'changes',
                }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!--Release Notes -->
              <ng-container *ngSwitchCase="'md-notes'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                    component: column.modalComponent,
                    resource: row,
                    property: 'notes',
                    title: 'Notes',
                    type: 'md-notes'
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>
              <!--  Notes -->
              <ng-container *ngSwitchCase="'notes'">
                <div
                  class="flex justify-between items-center"
                  [ngClass]="{
                    'gap-4': getObjectProperty(row, column.property)
                  }"
                >
                  <span>{{
                    formatLicenseNotes(getObjectProperty(row, column.property))
                  }}</span>
                  @if (getObjectProperty(row, column.property)?.length>30) {
                  <ctx-view-in-modal-button
                    *ngIf="column.modalComponent"
                    [config]="{
                      component: column.modalComponent,
                      resource: row,
                      property: 'notes',
                      title: 'Notes',
                      type: 'notes'
                    }"
                  ></ctx-view-in-modal-button>
                  }
                </div>
              </ng-container>
              <!-- Webhook Allowed Events -->
              <ng-container *ngSwitchCase="'allowedEvents'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                      component: column.modalComponent,
                      property: 'events',
                      resource: row,
                      title: 'Allowed Events',
                    }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!--Allowed Permission -->
              <ng-container *ngSwitchCase="'allowedPermission'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                    component: column.modalComponent,
                    resource: row,
                    property: column.property
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!-- Webhook Event Log Data -->
              <ng-container *ngSwitchCase="'webhookEventData'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                      component: column.modalComponent,
                      resource: row,
                    }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!-- Automated Email Log Data -->
              <ng-container *ngSwitchCase="'automatedEmailEventData'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                      component: column.modalComponent,
                      resource: row,
                      property: 'body',
                    }"
                ></ctx-view-in-modal-button>
              </ng-container>

              <!-- Array Data -->
              <ng-container *ngSwitchCase="'arrayData'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                      component: column.modalComponent,
                      resource: row,
                      title:  getResourceDisplayName(column.property,projectName),
                      property: column.property,
                  
                    }"
                ></ctx-view-in-modal-button>
              </ng-container>
              <!-- Tag -->
              <ng-container *ngSwitchCase="'tag'">
                <ctx-tag>{{ getObjectProperty(row, column.property) }}</ctx-tag>
              </ng-container>

              <!-- Tags -->
              <ng-container *ngSwitchCase="'tags'">
                <ng-container
                  *ngFor="let tag of getObjectProperty(row, column.property)"
                >
                  <ctx-tag [title]="getTagDescription(tag)">{{ tag }}</ctx-tag>
                </ng-container>
              </ng-container>

              <!-- Product -->
              <ng-container *ngSwitchCase="'product'">
                <span class="ph-no-capture">
                  {{
                    getName('product', getObjectProperty(row, column.property))
                  }}
                </span>
              </ng-container>

              <!-- Linked Products displays product names linked to the resource -->
              <ng-container *ngSwitchCase="'linkedProducts'">
                <div
                  class="flex justify-between items-center"
                  [ngClass]="{
                    'gap-4': getObjectProperty(row, 'productIds')
                  }"
                >
                  <span>{{
                    formatLinkedProducts(getObjectProperty(row, 'productIds'))
                      .products
                  }}</span>
                  @if (formatLinkedProducts(getObjectProperty(row,
                  'productIds')).viewButton) {
                  <ctx-view-in-modal-button
                    *ngIf="column.modalComponent"
                    [config]="{
                      component: column.modalComponent,
                      resource: row,
                      property: 'productIds',
                      title: 'Products',
                      type: 'linkedProducts'
                    }"
                  ></ctx-view-in-modal-button>
                  }
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="'entitlementSet'">
                <span class="ph-no-capture">
                  {{ getEntitlementSetName(row) }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'entitlements'">
                <ctx-view-in-modal-button
                  *ngIf="column.modalComponent"
                  [config]="{
                    component: column.modalComponent,
                    resource: row,
                    property: 'entitlementSetId',
                    title: 'Entitlement Set',
                    type: 'entitlements'
                  }"
                ></ctx-view-in-modal-button>
              </ng-container>
              <!-- Maintenance Policy -->
              <ng-container *ngSwitchCase="'maintenance-policy'">
                <span class="ph-no-capture">
                  {{
                    getName(
                      'maintenance-policy',
                      getObjectProperty(row, column.property)
                    )
                  }}
                </span>
              </ng-container>

              <!-- Product Version -->
              <ng-container *ngSwitchCase="'product-version'">
                <span class="ph-no-capture">
                  {{
                    getName(
                      'product-version',
                      getObjectProperty(row, column.property)
                    )
                  }}
                </span>
              </ng-container>
              <!-- Status -->
              <ng-container *ngSwitchCase="'status'">
                {{ getExpiryStatus(getObjectProperty(row, 'expiresAt')) }}
              </ng-container>
              <!-- Is license perpetual -->
              <ng-container *ngSwitchCase="'perpetual'">
                <span class="font-mono uppercase">
                  {{ isLicensePerpetual(row) }}
                </span>
              </ng-container>

              <!-- Webhook -->
              <ng-container *ngSwitchCase="'webhook'">
                <span class="ph-no-capture">
                  {{
                    getName('webhook', getObjectProperty(row, column.property))
                  }}
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'licenseSubscriptionInterval'">
                <span>
                  {{
                    formatISODuration(getObjectProperty(row, column.property))
                  }}
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'subscriptionStartTrigger'">
                <span class="font-mono uppercase">
                  {{
                    getSubscriptionStartTriggerLabel(
                      getObjectProperty(row, column.property)
                    )
                  }}
                </span>
              </ng-container>

              <!-- Automated Email -->
              <ng-container *ngSwitchCase="'automatedEmail'">
                <span class="ph-no-capture">
                  {{
                    getName(
                      'automated-email',
                      getObjectProperty(row, column.property)
                    )
                  }}
                </span>
              </ng-container>
              <!-- Release -->
              <!-- Show archive icon if archived -->
              <ng-container *ngSwitchCase="'release'">
                <span class="flex gap-1 items-center">
                  <hlm-icon
                    inline
                    class="opacity-80"
                    [name]="getIconForReleaseStatus(row)"
                    [matTooltip]="getHintForReleaseStatus(row)"
                  ></hlm-icon>
                  {{ getObjectProperty(row, column.property) }}
                </span>
              </ng-container>
              <!-- Created By -->
              <ng-container *ngSwitchCase="'createdBy'">
                <span class="ph-no-capture">
                  {{ getObjectProperty(row, 'user.name') }}
                </span>
              </ng-container>
              <!-- Default -->
              <ng-container *ngSwitchDefault>
                <span class="ph-no-capture">
                  {{ getObjectProperty(row, column.property) }}
                </span>
              </ng-container>
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- MatTable syntax to generate thead, tbody, tfoot -->
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
    <tr mat-row *matRowDef="let data; columns: columnsToDisplay"></tr>
  </table>
</section>
<table-paginator
  [resourceTableService]="resourceTableService"
  [showFirstLastButtons]="true"
  [tableContentRef]="tableWrapper"
></table-paginator>
